import { render, staticRenderFns } from "./SuggestionsExternal.vue?vue&type=template&id=ef17fb38"
import script from "./SuggestionsExternal.vue?vue&type=script&lang=js"
export * from "./SuggestionsExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports